// components/CheckoutForm.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import useCartStore from "../../store/cartStore";
import OrderComplete from "../../components/ordercomplete/ordercomplete";
import useStatusStore from "../../store/statusStore";

const CheckoutForm = () => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const cart = useCartStore((state) => state.cart);
    const totalPrice = useCartStore((state) => state.totalPrice)();
    const updateItem = useCartStore((state) => state.updateItem);

    const updateCustomerComment = useCartStore(
        (state) => state.updateCustomerComment
    );
    const removeItem = useCartStore((state) => state.removeItem);
    const increaseQuantity = useCartStore((state) => state.increaseQuantity);
    const decreaseQuantity = useCartStore((state) => state.decreaseQuantity);

    const [pickup, setPickup] = useState(true);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        street: "",
        zipCode: "",
        city: "",
    });

    const [completedOrder, setCompletedOrder] = useState({});

    const {
        deliveryAvailable,
        isInPickupTime,
        isInDeliveryTime,
        orderAvailable,
        fetchDeliveryAvailable,
        fetchOrderAvailable,
        fetchIsInDeliveryTime,
        fetchInPickupTime,
    } = useStatusStore();

    useEffect(() => {
        fetchDeliveryAvailable();
        fetchOrderAvailable();
        fetchIsInDeliveryTime();
        fetchInPickupTime();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleCommentChange = (itemId, beilage, comment) => {
        updateCustomerComment(itemId, beilage, comment);
    };

    const handleQuantityChange = (itemId, beilage, increase) => {
        if (increase) {
            increaseQuantity(itemId, beilage);
        } else {
            decreaseQuantity(itemId, beilage);
        }
    };

    const handleSideDishChange = (itemId, beilage, newSideDish) => {
        // Find the current item being updated
        const currentItem = cart.find(
            (item) => item.id === itemId && item.beilage === beilage
        );

        if (currentItem) {
            // Find a potential merge target: an item with the same `id` and `beilage`
            const mergeTarget = cart.find(
                (item) => item.id === itemId && item.beilage === newSideDish
            );

            if (mergeTarget) {
                // Merge the quantities
                const mergedQuantity =
                    mergeTarget.quantity + currentItem.quantity;

                // Merge the customer comments
                const mergedComment = [
                    mergeTarget.customerComment,
                    currentItem.customerComment,
                ]
                    .filter(Boolean) // Remove empty comments
                    .join("; "); // Concatenate with a semicolon separator

                // Update the merge target with new quantity and merged comment
                updateItem(mergeTarget.id, newSideDish, {
                    quantity: mergedQuantity,
                    customerComment: mergedComment,
                });

                // Remove the original item after merging
                removeItem(currentItem.id, currentItem.beilage);
            } else {
                updateItem(itemId, beilage, { beilage: newSideDish });
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        {
            /* Check minimum value 30 Euro for delivey */
            if (!pickup && totalPrice < 30) {
                alert(
                    "Der Mindestbestellwert für Lieferungen beträgt 30 Euro. Bitte fügen Sie weitere Artikel hinzu."
                );
                setSubmitLoading(false);
                return;
            }
        }
        if (
            !formData.firstName ||
            !formData.lastName ||
            !formData.email ||
            !formData.phoneNumber
        ) {
            alert("Bitte füllen Sie alle Pflichtfelder aus.");
            return;
        }

        if (
            !pickup &&
            (!formData.city || !formData.zipCode || !formData.street)
        ) {
            alert(
                "Bitte geben Sie Ihre vollständige Adresse und Postleitzahl für die Lieferung ein."
            );
            return;
        }

        const orderData = {
            formData: formData,
            pickup: pickup,
            cart: cart,
        };

        try {
            const response = await axios.post("/api/public/orders", orderData);
            // Clear the cart
            useCartStore.setState({ cart: [] });
            setCompletedOrder(response.data);
        } catch (error) {
            //If statis code is 400, show the error message
            if (error.response.status === 400) {
                alert(error.response.data.message);
            } else {
                alert(
                    "Die Bestellung ist fehlgeschlagen. Bitte versuchen Sie es erneut."
                );
            }
        }
        setSubmitLoading(false);

        // scroll to top
        window.scrollTo(0, 0);
    };

    return (
        <>
            {orderAvailable === false && (
                <div className="bg-red-500 text-white text-center p-4">
                    <p>
                        Bestellungen sind derzeit nicht möglich. Sie erreichen
                        uns <a href="tel:072449469991">telefonisch</a>
                    </p>
                </div>
            )}
            {orderAvailable && (
                <form
                    onSubmit={handleSubmit}
                    className={
                        "max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-md space-y-6 my-16" +
                        (completedOrder && completedOrder.totalPrice
                            ? " hidden"
                            : "")
                    }
                >
                    <h1 className="text-2xl font-bold text-center">Kasse</h1>

                    <div className="cart-items space-y-4">
                        {Object.values(cart).map((item) => (
                            <div
                                key={
                                    item.id +
                                    (item.sideDish ? item.beilage : "")
                                }
                                className="flex flex-col md:flex-row md:justify-between items-start bg-gray-100 p-4 rounded-lg"
                            >
                                <div className="flex-1 space-y-2">
                                    <p className="text-lg font-semibold">
                                        {item.title}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        {item.description}
                                    </p>
                                    <div
                                        className={
                                            "flex flex-col -ml-1 mt-2 w-2/3" +
                                            (item.beilage === ""
                                                ? " hidden"
                                                : "")
                                        }
                                    >
                                        <select
                                            id={"select" + item.id}
                                            name="sideDish"
                                            value={item.beilage}
                                            onChange={(e) =>
                                                handleSideDishChange(
                                                    item.id,
                                                    item.beilage,
                                                    e.target.value
                                                )
                                            }
                                            className="p-2 border border-gray-300 rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        >
                                            <option value="Pommes">
                                                mit Pommes
                                            </option>
                                            <option value="Reis">
                                                mit Reis
                                            </option>
                                            <option value="Kroketten">
                                                mit Kroketten
                                            </option>
                                            <option value="Kartoffelchips">
                                                mit Kartoffelchips
                                            </option>
                                            <option value="Bandnudeln">
                                                mit Bandnudeln
                                            </option>
                                        </select>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <button
                                            type="button"
                                            onClick={() =>
                                                handleQuantityChange(
                                                    item.id,
                                                    item.beilage,
                                                    false
                                                )
                                            }
                                            className="px-2 py-1 bg-gray-300 text-black rounded hover:bg-gray-400"
                                        >
                                            -
                                        </button>
                                        <p className="text-sm font-semibold">
                                            {item.quantity}
                                        </p>
                                        <button
                                            type="button"
                                            onClick={() =>
                                                handleQuantityChange(
                                                    item.id,
                                                    item.beilage,
                                                    true
                                                )
                                            }
                                            className="px-2 py-1 bg-gray-300 text-black rounded hover:bg-gray-400"
                                        >
                                            +
                                        </button>
                                    </div>

                                    <div className="w-full flex flex-row items-center space-x-4">
                                        <p className="text-sm font-semibold">
                                            Einzelpreis: {item.price.toFixed(2)}
                                            €
                                        </p>
                                        <p
                                            className={
                                                "text-sm font-semibold" +
                                                (item.quantity > 1
                                                    ? ""
                                                    : " hidden")
                                            }
                                        >
                                            Summe:{" "}
                                            {(
                                                item.price * item.quantity
                                            ).toFixed(2)}
                                            €
                                        </p>
                                    </div>
                                </div>

                                <div className="w-full h-full mt-2 md:mt-0 md:w-1/2">
                                    <label
                                        htmlFor={`comment-${item.id}`}
                                        className="text-sm font-semibold"
                                    >
                                        Kommentar:
                                    </label>
                                    <textarea
                                        id={`comment-${item.id}`}
                                        value={item.customerComment}
                                        onChange={(e) =>
                                            handleCommentChange(
                                                item.id,
                                                item.beilage,
                                                e.target.value
                                            )
                                        }
                                        className="w-full h-24 p-2 border border-gray-300 rounded mt-1 resize-none text-sm"
                                        rows="4"
                                    />
                                </div>
                            </div>
                        ))}
                        <h2 className="text-xl font-bold text-right">
                            Gesamtpreis: {totalPrice.toFixed(2)}€
                            {pickup === false && totalPrice < 30 && (
                                <span className="text-red-500">
                                    {" "}
                                    (min. 30€)
                                </span>
                            )}
                        </h2>
                    </div>

                    <div className="delivery-options space-y-2">
                        <label className="flex items-center space-x-2">
                            <input
                                type="radio"
                                name="pickupOrDelivery"
                                value="pickup"
                                checked={pickup}
                                onChange={() => setPickup(true)}
                                disabled={!isInPickupTime}
                                className="h-4 w-4"
                            />
                            <span>
                                Abholung am Restaurant{" "}
                                {!isInPickupTime && (
                                    <span className="text-red-500">
                                        (außerhalb der Abholzeiten)
                                    </span>
                                )}
                            </span>
                        </label>
                        <label className="flex items-center space-x-2">
                            <input
                                type="radio"
                                name="pickupOrDelivery"
                                value="delivery"
                                disabled={
                                    !isInDeliveryTime || !deliveryAvailable
                                }
                                checked={!pickup}
                                onChange={() => setPickup(false)}
                                className="h-4 w-4"
                            />
                            <span>
                                Lieferung{" "}
                                {!deliveryAvailable && (
                                    <span className="text-red-500">
                                        wegen hoher Auslastung nicht verfügbar
                                    </span>
                                )}
                                {deliveryAvailable && !isInDeliveryTime && (
                                    <span className="text-red-500">
                                        {" "}
                                        (außerhalb der Lieferzeiten)
                                    </span>
                                )}
                            </span>
                        </label>
                    </div>

                    {!pickup && (
                        <>
                            <div className="form-group">
                                <label
                                    htmlFor="street"
                                    className="text-sm font-semibold"
                                >
                                    Straße und Hausnummer
                                </label>
                                <input
                                    type="text"
                                    id="street"
                                    name="street"
                                    value={formData.street}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border border-gray-300 rounded mt-1"
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="zipCode"
                                    className="text-sm font-semibold"
                                >
                                    Postleitzahl
                                </label>
                                <input
                                    type="text"
                                    id="zipCode"
                                    name="zipCode"
                                    value={formData.zipCode}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border border-gray-300 rounded mt-1"
                                />
                            </div>
                            <div className="form-group">
                                <label
                                    htmlFor="city"
                                    className="text-sm font-semibold"
                                >
                                    Ort
                                </label>
                                <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border border-gray-300 rounded mt-1"
                                />
                            </div>
                        </>
                    )}

                    <div className="form-group">
                        <label
                            htmlFor="firstName"
                            className="text-sm font-semibold"
                        >
                            Vorname
                        </label>
                        <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            required
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="lastName"
                            className="text-sm font-semibold"
                        >
                            Nachname
                        </label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            required
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="email"
                            className="text-sm font-semibold"
                        >
                            E-Mail
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="phoneNumber"
                            className="text-sm font-semibold"
                        >
                            Telefonnummer
                        </label>
                        <input
                            type="tel"
                            id="phoneNumber"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleInputChange}
                            required
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </div>

                    <div className="form-group">
                        <label className="text-sm font-semibold">
                            Zahlungsmethode
                        </label>
                        <p className="text-gray-600">
                            {pickup
                                ? "Barzahlung und Kartenzahlung"
                                : "Nur Barzahlung"}
                        </p>
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-enedemgreen text-white font-semibold py-2 rounded hover:bg-green-800"
                    >
                        {submitLoading ? "Warten..." : "Bestellung abschicken"}
                    </button>
                </form>
            )}
            <div className={completedOrder ? "" : "hidden"}>
                {completedOrder && completedOrder.totalPrice && (
                    <OrderComplete order={completedOrder} />
                )}
            </div>
        </>
    );
};

export default CheckoutForm;
